import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { CircularProgress, Dialog, IconButton, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { getOriginalFileName } from "utils/utils";

/** Large view of an image attachment, with a shortcut to open the original file in a new tab. */
const AttachmentLightbox = ({ url, open, onClose, onError }) => {
  const [loaded, setLoaded] = useState(false);
  const name = getOriginalFileName(url) || "Image";

  useEffect(() => {
    if (open) setLoaded(false);
  }, [open, url]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      aria-label={`Preview of ${name}`}
      PaperProps={{ sx: { bgcolor: "var(--app-surface)", backgroundImage: "none" } }}
    >
      <div className="flex items-center gap-2 border-b border-app-border px-4 py-2">
        <span className="min-w-0 flex-1 truncate text-sm font-medium text-app-text" title={name}>
          {name}
        </span>
        <Tooltip title="Open in new tab">
          <IconButton
            size="small"
            component="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open in new tab"
          >
            <OpenInNewIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Close">
          <IconButton size="small" onClick={onClose} aria-label="Close preview">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>
      <div className="relative flex min-h-[200px] items-center justify-center bg-app-surface-muted p-2">
        {!loaded && (
          <span className="absolute inset-0 flex items-center justify-center">
            <CircularProgress size={28} />
          </span>
        )}
        <img
          src={url}
          alt={name}
          onLoad={() => setLoaded(true)}
          onError={onError}
          className={`max-h-[78vh] max-w-full object-contain transition-opacity ${
            loaded ? "opacity-100" : "opacity-0"
          }`}
        />
      </div>
    </Dialog>
  );
};

export default AttachmentLightbox;
